import { render, staticRenderFns } from "./beforeClaim.vue?vue&type=template&id=2982a5b2&scoped=true"
import script from "./beforeClaim.vue?vue&type=script&lang=js"
export * from "./beforeClaim.vue?vue&type=script&lang=js"
import style0 from "./beforeClaim.vue?vue&type=style&index=0&id=2982a5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2982a5b2",
  null
  
)

export default component.exports